import React, { FC, Fragment } from 'react'
import {
  Button,
  DrawerBody,
  DrawerCloseButton,
  DrawerFooter,
  DrawerHeader,
  Heading,
  Text,
  Stack,
} from '@chakra-ui/react'

import { Empty, Loader } from 'components'

import GambiarraFilterTags from 'InstitutionalManagement/components/SalaryFilterTags'
import CustomFormSalaryCardToSelect from './components/CustomFormSalaryCardToSelect'
import { useCustomFormSalarySelectionDrawerManager } from '../../contexts/CustomFormSalarySelectionDrawerManager/Provider'

type Props = {
  onClose: () => void
}

const SelectSalaryOnCustomForm: FC<Props> = ({ onClose }) => {
  const { loadingSalaries, salaries, setView, filter, setFilter } = useCustomFormSalarySelectionDrawerManager()

  return (
    <>
      <DrawerCloseButton />

      <DrawerHeader>
        <Text>Salários disponíveis</Text>
        <Heading color="primary">Selecione um salário</Heading>
      </DrawerHeader>

      <DrawerBody overflowY="auto">
        <GambiarraFilterTags px={4} pb={4} salaryFilter={filter} setSalaryFilter={setFilter} />

        {loadingSalaries ? (
          <Loader text={'Carregando salários disponíveis'} />
        ) : (
          <Fragment>
            {salaries.length > 0 ? (
              <Stack>
                {salaries.map((salary) => (
                  <CustomFormSalaryCardToSelect key={salary.id} salary={salary} onClose={onClose} />
                ))}
              </Stack>
            ) : (
              <Empty title={'Nenhum salário encontrado'} description="Sua busca não retornou registros" />
            )}
          </Fragment>
        )}
      </DrawerBody>

      <DrawerFooter>
        <Button variant="outline" onClick={() => setView('SEARCH_SALARY')}>
          Voltar
        </Button>

        <Button onClick={onClose}>Concluir</Button>
      </DrawerFooter>
    </>
  )
}

export default SelectSalaryOnCustomForm
